<template>
  <div v-loading="loading">
    <section>
      <article class="mt-5">
        <div class="container mt-5">

          <div class="row w-100 mb-4">
            <div class="col-12 pl-3 px-0 mb-0 text-left">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/smartlodge/admin/' }">Home</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/smartlodge/admin/categories' }">Categories</el-breadcrumb-item>
                <el-breadcrumb-item>{{$route.params.category_name }} - Products</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>

          <h3><b>Products in "{{$route.params.category_name }}" Category:</b></h3>
          <div
            style="display: flex; align-items:center; justify-content: space-between;"
            class="search_add_section"
          >
            <div style="width: 50%;">
              <input
                type="text"
                v-model.trim="filters[0].value"
                placeholder="Search by Name"
                class="search_by_input form-control"
                spellcheck="off"
              />
            </div>
            <div>
              <el-button
                type="primary"
                :disabled="false"
                @click="$router.push( { path: `/smartlodge/admin/category/${$route.params.category_id}/${$route.params.category_name}/add-product` } )"
                round
              >Add Product</el-button>
            </div>
          </div>
          <hr />

          <div
            v-loading="loading || is_changing"
            class="table-responsive mb-5"
          >
            <data-tables
              :data="products"
              :table-props="tableProps"
              :pagination-props="{ pageSizes: [5, 20, 25, 50, 100] }"
              type="expand"
              :filters="filters"
            >

              <div slot="empty">
                <ScaleOut
                  v-if="isLoading && !loadingError"
                  class="mt-3"
                  :background="'#164B70'"
                />
                <div
                  @click="getProducts"
                  v-else-if="!isLoading && loadingError"
                  style="cursor: pointer"
                >
                  Unable to Load Products Now. Please click here to retry
                </div>
                <div v-if="!isLoading && !loadingError">No Products</div>
              </div>

              <el-table-column
                label="#"
                :show-overflow-tooltip="false"
                label-class-name="text-center"
                class-name="text-center"
                width="80px"
              >
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Main Image"
                :show-overflow-tooltip="false"
                label-class-name="text-left"
                width="75px"
              >
                <template slot-scope="scope">
                  <img
                    :src="scope.row.main_image"
                    style="width: 50px; height: 50px; border-radius: 50%; object-fit: cover;"
                  >
                </template>
              </el-table-column>

              <el-table-column
                label="Product Name"
                :show-overflow-tooltip="false"
                label-class-name="text-left"
                class-name="text-left"
              >
                <template slot-scope="scope">
                  <!-- {{ scope.row.product_groups.length }}<br /> -->
                  <span> {{ scope.row.product_name }} </span><br />
                  <small>Add On: {{ formattedDate(scope.row.created_date) }} </small><br />
                  <small>Edited On: {{ formattedDate(scope.row.updated_date) }} </small>
                </template>
              </el-table-column>

              <el-table-column
                label="Colors"
                :show-overflow-tooltip="false"
                label-class-name="text-center"
                class-name="text-center"
              >
                <template slot-scope="scope">
                  <ColorsDialog
                    :numberOfColors="scope.row.number_of_colors"
                    :productId="scope.row.product_id"
                    :categoryId="$route.params.category_id"
                    @re-fresh="getProducts"
                  />

                </template>
              </el-table-column>

              <el-table-column
                label="Sizes"
                :show-overflow-tooltip="false"
                label-class-name="text-center"
                class-name="text-center"
              >
                <template slot-scope="scope">
                  <SizesDialog
                    :numberOfSizes="scope.row.number_of_sizes"
                    :productId="scope.row.product_id"
                    :categoryId="$route.params.category_id"
                    @re-fresh="getProducts"
                  />
                </template>
              </el-table-column>

              <el-table-column
                label="Product Groups"
                :show-overflow-tooltip="false"
                label-class-name="text-center"
                class-name="text-center"
              >
                <template slot-scope="scope">
                  <AssignProductProductGroups
                    :productGroupsNumber="scope.row.product_groups"
                    :productId="scope.row.product_id"
                    @re-fresh="getProducts"
                  />
                </template>
              </el-table-column>

              <el-table-column
                label="Status"
                label-class-name="text-center"
                class-name="text-center"
                width="100px"
              >
                <template slot-scope="scope">
                  <el-row style="display: flex;">
                    <el-tooltip
                      :content="scope.row.is_active ? 'Active' : 'Deactivated'"
                      placement="top"
                    >
                      <el-switch
                        v-model="scope.row.is_active"
                        @change="switchStatus(scope.row.is_active, scope.row.product_id)"
                        active-color="#13ce66"
                        inactive-color=""
                      >
                      </el-switch>
                    </el-tooltip>
                  </el-row>
                </template>
              </el-table-column>

              <el-table-column
                label="Actions"
                :show-overflow-tooltip="false"
                label-class-name="text-center"
                class-name="text-center"
              >
                <template slot-scope="scope">
                  <el-row style="display: flex; align-items:center; justify-content:center;">
                    <el-tooltip
                      content="Edit"
                      placement="top"
                    >
                      <el-button
                        type="warning"
                        :disabled="false"
                        @click="showEditProductData(scope.row.product_id)"
                        icon="el-icon-edit"
                        circle
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Delete"
                      placement="top"
                    >
                      <el-button
                        type="danger"
                        :disabled="false"
                        @click="deleteProduct(scope.row.product_id)"
                        icon="el-icon-delete"
                        circle
                      ></el-button>
                    </el-tooltip>
                  </el-row>
                </template>
              </el-table-column>

            </data-tables>
          </div>

        </div>
      </article>
    </section>
  </div>
</template>

<script>
import ScaleOut from "@/components/backoffice/scale-out-component.vue";
import SizesDialog from "../../components/backoffice/dialogs/sizes-dialog.vue";
import ColorsDialog from "../../components/backoffice/dialogs/colors-dialog.vue";
import AssignProductProductGroups from "../../components/backoffice/dialogs/assign-product-product-groups.vue";
import { format, parseISO } from "date-fns";
export default {
  components: {
    ScaleOut,
    SizesDialog,
    ColorsDialog,
    AssignProductProductGroups,
  },

  data() {
    return {
      loading: false,
      isLoading: false,
      is_changing: false,
      showUserEditDialog: false,
      products: [],
      user_data: {},

      tableData: [],
      tableProps: {
        border: true,
        stripe: true,
      },
      filters: [
        {
          prop: "fullname",
          value: "",
        },
      ],
      loadingError: false,
    };
  },

  computed: {
    formattedDate() {
      return (dateString) => format(parseISO(dateString), "do MMM yyyy hh:mma");
    },
  },

  mounted() {
    this.getProducts();
  },

  methods: {
    showEditProductData(product_id) {
      this.$router.push({
        path: `/smartlodge/admin/category/${this.$route.params.category_id}/${this.$route.params.category_name}/edit-product/${product_id}`,
      });
    },

    closeEditUserData() {
      this.showUserEditDialog = false;
    },

    async getProducts() {
      this.isLoading = true;
      this.isLoadingError = false;
      try {
        //TODO: MAKE THIS REQUEST DYNAMIC AND NOT STATIC
        let request = await this.$http.get(
          `categories/${this.$route.params.category_id}`
        );
        if (request.data.success) {
          this.products = request.data.products;
        } else throw "UNEXPECTED_RESPONSE_RECEIVED";
      } catch (error) {
        this.isLoadingError = true;
        //TODO: REPORT THIS TO AN ERROR REPORTING SERVICE
        this.$notify({
          title: "Operation Failed",
          message: "Unable to fetch products now, please try again",
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async switchStatus(activation_status, productId) {
      try {
        this.is_changing = true;
        let request = await this.$http.patch(
          `products/change_is_active_status/${productId}`, {
            is_active: activation_status,
          }
        );
        if (
          request.data.success &&
          request.data.message == "PRODUCT_IS_ACTIVE_STATUS_CHANGED_SUCCESSFULLY"
        ) {
          this.getProducts();
          this.showSuccessMessage("Success", );
              return this.$notify({
                title: "Success",
                message: "Product status changed",
                type: "success",
              });
        } else {
          throw "UNEXPECTED_RESPONSE";
        }
      } catch (error) {
        if (error.message == "Network Error") {
          this.is_changing = false;
          return this.showFailedMessage(
            "Connection failed",
            "A network error occurred, please try again."
          );
        }
        this.loadingError = true;
        this.showFailedMessage(
          "Unable to change staff status",
          "An unexpected error occurred, please try again"
        );
      } finally {
        this.is_changing = false;
      }
    },

    async deleteProduct(product_id) {
      this.$confirm(
        // eslint-disable-line no-unreachable
        "This will permanently delete this Product. Do you want to Continue?",
        "Confirm delete",
        {
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            this.deleting = true;
            let request = await this.$http.delete(`products/${product_id}`);
            if (
              request.data.success &&
              request.data.message === "PRODUCT_DELETED_SUCCESSFULLY"
            ) {
              this.getProducts();
              this.$notify({
                title: "Success",
                message: "Product deleted successfully!",
                type: "success",
              });
            } else {
              throw "UNEXPECTED_RESPONSE";
            }
          } catch (error) {
            if (error.message == "Network Error") {
              this.loadingError = true;
              return this.$notify({
                title: "Connection failed",
                message: "A network error occurred, please try again.",
                type: "error",
              });
            }
            this.$notify({
              title: "Unable to Delete",
              message: "Unable to delete the User, Please try again",
              type: "error",
            });
          } finally {
            this.deleting = false;
          }
        })
        .catch(() => {
          //
        });
    },
  },
};
</script>

<style>
.el-form-item {
  margin-bottom: 0px;
}

.el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 0px;
}
label {
  display: inline-block;
  margin-bottom: 0px;
}
</style>